import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import "./utils/antDStyles/customizedantdstyle.scss";
import PageLayout from "./layouts/PageLayout";
import ProtectedRoute from "./routes/ProtectedRoute";
import Notification from "./shared/notification/Notification";
import {
  getnotificationdata,
  notificationlist,
  updatefirebasetoken,
  updatenotificationcount,
} from "./store/Common/CommonSlice";
import { Suspense, lazy, useEffect } from "react";
import { Skeleton, notification } from "antd";
import { getToken, onMessage } from "firebase/messaging";
import firebase from "./firebase";
import { authtoken } from "./store/Authentication/AuthSlice";
import AwbTrackingPage from "./components/User/TrackingComponent/TrackingDetail";
import config from "./config";
const CmaModule = lazy(() => import("./cma/CmaModule"));
const Login = lazy(() => import("./layouts/Login"));
const HomeLanding = lazy(() => import("./pages/HomeLanding"));
const KybReviewConsole = lazy(() => import("./modules/kyb/manager/KybConsoleEntry"));
const LoginForm = lazy(() => import("./components/Authentication/LoginForm"));
const SignupForm = lazy(() => import("./components/Authentication/SignupForm"));
const ForgotPasswordForm = lazy(() =>
  import("./components/Authentication/ForgotPasswordForm")
);
const ChangePasswordForm = lazy(() =>
  import("./components/Authentication/ChangePasswordForm")
);

const BusinessVerificationRedirect = () => {
  const { search, hash } = useLocation();
  return <Navigate to={`/user/business-verification${search}${hash}`} replace />;
};

function App() {
  const notificationData = useSelector(getnotificationdata);
  const getauthtoken = useSelector(authtoken);
  const dispatch = useDispatch();

  // Firebase messaging instance from ./firebase — null when this browser
  // doesn't support push, in which case notifications are simply skipped.
  const messaging = firebase;
  if (messaging) onMessage(messaging, (payload) => {
    //console.log('Message received. ', payload);
    dispatch(notificationlist(10))
      .then((res) => {
        if (res?.payload?.data?.statusCode === 200) {
          dispatch(updatenotificationcount(res?.payload?.data?.newCount));
          notification.open({
            message: payload?.notification?.title,
            description: payload?.notification?.body,
            onClick: () => {
              console.log("Notification Clicked!");
            },
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  });

  useEffect(() => {
    if (!messaging) return;
    getToken(messaging, {
      vapidKey:
        "BA7TxqwNz4Er_lGHXZ-HmivAf-HTyCwamFjfAw7lIHjvERODTiY3gQS4-CZF9F_IhNixu8vDO1Nc1FaB5RqxXDg",
    })
      .then((currentToken) => {
        if (currentToken) {
          dispatch(updatefirebasetoken(currentToken));
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });
  }, [messaging]);

  // const messaging = firebase.messaging();
  // useEffect(()=>{
  //     const requestFirebaseNotificationPermission = async () => {
  //         try {
  //           const token = await messaging.getToken();
  //           console.log('ttt => ',token);
  //           return token;
  //         } catch (error) {
  //           console.error("Error obtaining FCM token:", error);
  //         }
  //       };
  //       requestFirebaseNotificationPermission();
  // },[messaging])
  return (
    <>
      <Routes>
      

        <Route
          path="/auth/*"
          element={
              <Suspense fallback={<Skeleton active />}>
                <Login />
              </Suspense>
          }
        >
          <Route
            path="login"
            index
            element={
              <Suspense fallback={<Skeleton active />}>
                <LoginForm />
              </Suspense>
            }
          />
          <Route
            path="signup"
            element={
              <Suspense fallback={<Skeleton active />}>
                <SignupForm />
              </Suspense>
            }
          />
          <Route
            path="forgotpassword"
            element={
              <Suspense fallback={<Skeleton active />}>
                <ForgotPasswordForm />
              </Suspense>
            }
          />
          <Route
            path="changepassword/:id/:token"
            element={
              <Suspense fallback={<Skeleton active />}>
                <ChangePasswordForm />
              </Suspense>
            }
          />
          <Route
            path="updatepassword"
            element={
              <Suspense fallback={<Skeleton active />}>
                <ChangePasswordForm />
              </Suspense>
            }
          />
          <Route path="*" element={<Navigate to="login" replace />} />
        </Route>
        {/* Post-login landing / mode-selection page. Kept as its OWN top-level
            protected route (outside PageLayout) so it paints instantly with a
            minimal top bar — it never mounts the heavy app layout (sidebar,
            socket context, firebase, usertour). */}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Suspense fallback={<Skeleton active />}>
                <HomeLanding />
              </Suspense>
            </ProtectedRoute>
          }
        />
        {/* Business verification (KYB) is only served inside the user layout
            (/user/business-verification, ACL-guarded by PageLayout). The old
            standalone path just redirects there, keeping the query string so
            DigiLocker's ?dl_return=1 links still resume the flow. */}
        <Route path="/business-verification" element={<BusinessVerificationRedirect />} />
        {/* KYB review console (KYB manager) — standalone page with its own top bar and menu, like /home. */}
        <Route
          path="/kyb-manager/*"
          element={
            <ProtectedRoute>
              <Suspense fallback={<Skeleton active />}>
                <KybReviewConsole />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cma"
          element={
            <ProtectedRoute>
              <CmaModule apiBase={`${config.apiBaseUrl}cma`} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <PageLayout />
            </ProtectedRoute>
          }
        />
          <Route
            path="track/:encodedAwbNumber"
            element={
              <Suspense fallback={<Skeleton active />}>
                <AwbTrackingPage  type="public" />
              </Suspense>
            }
          />
        {/* <Route path="*" element={<Navigate to={getauthtoken ? "/" : "/auth/login"} replace />} /> */}
        {/* <Route path='/*' element={<ProtectedRoute> <PageLayout/> </ProtectedRoute>}/> */}
        {/* <Route path='*' element={<Login/>}/> */}
      </Routes>
      {notificationData?.success && notificationData?.message && (
        <>
          <Notification notificationData={notificationData} />
        </>
      )}
    </>
  );
}

export default App;
